import { ActionType } from "../action-types";
import { UpdateLoadingStateAction } from "../actions";
import { LoadingStateChange } from "../../models";

const initialLoadingState: LoadingStateChange = {loading: false}

const loadingStateReducer = (state: LoadingStateChange = initialLoadingState, action: UpdateLoadingStateAction ) => {
    switch (action.type) {
        case ActionType.UpdateLoading:
            return state = action.payload
        default:
            return state
    }
}

export default loadingStateReducer